import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@assets/GoodGirlKarma/page1-min.jpg'
import _imports_1 from '@assets/GoodGirlKarma/page12-min.jpg'
import _imports_2 from '@assets/GoodGirlKarma/page7-min.jpg'
import _imports_3 from '@assets/GoodGirlKarma/page14-min.jpg'


const _hoisted_1 = { class: "container flex flex-col items-center mx-auto text-color md:flex-row " }
const _hoisted_2 = { class: "justify-center w-full px-12 pt-6 pb-6 align-items: center lg:w-1/2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "w-full shadow-xl",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "w-full shadow-xl",
  src: _imports_1
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "w-full shadow-xl",
  src: _imports_2
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "w-full shadow-xl",
  src: _imports_3
}, null, -1)
const _hoisted_7 = { class: "flex flex-col items-center w-full text-center text-indigo-400 lg:w-1/2 lg:py-6" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"text-7xl mb-8\">Good Girl, Karma</div><div class=\"m-4 text-6xl\">Meet Karma!</div><div class=\"m-2 text-4xl\">A golden retriever who likes to do good things.</div><div class=\"m-4\">Let&#39;s discover all the ways Karma is a good dog!</div><div class=\"m-4\">A book for beginning readers, with beautiful illustrations.</div>", 5)
const _hoisted_13 = { class: "m-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "pb-10 text-4xl font-bold" }, "About the Book", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "pb-10" }, " Good Girl Karma is published as a quality softcover book, with durable pages. Each page has a short, easy to read phrase on the left side, and a beautiful illustration on the right side. There are 15 illustrated pages. ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "pb-2 ml-10" }, " \"Karma likes to play games with you.\" ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "pb-10 ml-10" }, "\"Good Girl, Karma.\"", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "pb-10" }, " This book will appeal to pre-readers, young readers, children who love dogs (especially Golden Retrievers) and anyone who had a very special dog in their life. ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "pb-10" }, " Each book will be signed by the author, and you can have a special dedication to the child you're giving the book to. Imagine giving a special gift with a message from the author, addressed to your child or grandchild! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_agile = _resolveComponent("vue-agile")
  const _component_buy_button = _resolveComponent("buy-button")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_vue_agile, {
            options: _ctx.agileOptions,
            class: _ctx.carouselVisibility,
            "nav-buttons": "false",
            speed: "2500",
            fade: "",
            "pause-on-hover": "",
            autoplay: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }, 8, ["options", "class"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_buy_button, { label: "Buy 'Good Girl, Karma'" })
        ])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_box, { class: "p-5 bg-white" }, {
          default: _withCtx(() => [
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _createVNode(_component_buy_button, {
              class: "my-4",
              label: "Buy 'Good Girl, Karma'"
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}